import { supabase } from '@/lib/supabase-unified'
import type { Course, Lesson } from '@/types'

export type LessonSidebarSeason = {
  id: number
  title: string
  first_lesson_slug: string
}

export type LessonSidebarData = {
  course: Course
  season_sequence: {
    id: number
    title: string
    type: number
    slug?: string
  } | null
  current_season: LessonSidebarSeason | null
  seasons: LessonSidebarSeason[]
  lessons: (Lesson & {
    main_work_title: string | null
    category_position: number | null
    /** Companion (individually-sold) lesson the user doesn't own. */
    locked?: boolean
    /** External checkout URL for locked companion lessons (web only). */
    buy_url?: string | null
  })[]
}

export async function fetchLessonSidebar(input: {
  courseSlug: string
  lessonSlug: string
  userId: string | null
}): Promise<LessonSidebarData> {
  const { data, error } = await supabase.rpc('get_lesson_sidebar_v1', {
    p_course_slug: input.courseSlug,
    p_lesson_slug: input.lessonSlug,
    p_user_id: input.userId ?? null,
  })
  if (error) {
    throw new Error(`Supabase Error: ${error.message}`)
  }
  return data as LessonSidebarData
}
